import React, { Component } from 'react';

import Player from './../Player/Player';

//Category images
import sub6Img from './../../images/categories/Sub 6.jpg'
import sub8Img from './../../images/categories/Sub 8.JPG'
import sub10Img from './../../images/categories/Sub 10.JPG'
import sub12Img from './../../images/categories/Sub 12.JPG'
import sub14Img from './../../images/categories/Sub 14.JPG'
import sub16Img from './../../images/categories/Sub 16.JPG'
import sub18Img from './../../images/categories/Sub 18.jpg'


class Team extends Component {

	constructor(){
		super()
		this.state = {
			category: 'sub6',
			players: []
		}

		this.chooseCategory = this.chooseCategory.bind(this)
	}

	componentDidMount(){
	let chosenData = this.props.data.filter(item=>{
    	return item.sys.contentType.sys.id === this.state.category;
    })

    this.setState({players: chosenData});

}

chooseCategory = (category) =>{
    this.setState({category: category,
    				players: []});

    let chosenData = this.props.data.filter(item=>{
    	return item.sys.contentType.sys.id === category;
    })

    this.setState({players: chosenData});

  }

      
	render() {

		let { category, players } = this.state
		let body;
		if (players.length > 0){
			let i = -1;
			const playersList = players.map((player) =>{
					i++;
					return (<div>
								<Player key={i} player={player.fields} category={category}/>
							</div>
							);
				})

			body = <div className="playersContainer">
								<div className="centerDiv">
									{playersList}
								</div>
							</div>;

		}else{
			body = <h3>Los atletas de esta categoría aún no están disponibles</h3>
		}

		let categoryPicture;
		switch(category){
			case 'sub6':
				categoryPicture  = <img src={sub6Img} className="cover px-3" alt={category}/>;
				break;
			case 'sub8':
				categoryPicture  = <img src={sub8Img} className="cover px-3" alt={category}/>;
				break;
			case 'sub10':
				categoryPicture  = <img src={sub10Img} className="cover px-3" alt={category}/>;
				break;
			case 'sub12':
				categoryPicture  = <img src={sub12Img} className="cover px-3" alt={category}/>;
				break;
			case 'sub14':
				categoryPicture  = <img src={sub14Img} className="cover px-3" alt={category}/>;
				break;
			case 'sub16':
				categoryPicture  = <img src={sub16Img} className="cover px-3" alt={category}/>;
				break;
			case 'sub18':
				categoryPicture  = <img src={sub18Img} className="cover px-3" alt={category}/>;
				break;
			default:
				categoryPicture  = <img src={sub6Img} className="cover px-3" alt={category}/>;
				break;
		}
		
		return (
		<div>
		<h1>Equipo Eidefut</h1>
			<div className="btn-group" role="group" aria-label="Basic example">
			    <button type="button" className={`btn-team ${category === "sub6" ? "active-team" : null}`} title="Sub-6" onClick={() => this.chooseCategory('sub6')}>Sub-6</button>
			    <button type="button" className={`btn-team ${category === "sub8" ? "active-team" : null}`} title="Sub-8" onClick={() => this.chooseCategory('sub8')}>Sub-8</button>
			    <button type="button" className={`btn-team ${category === "sub10" ? "active-team" : null}`} title="Sub-10" onClick={() => this.chooseCategory('sub10')}>Sub-10</button>
			    <button type="button" className={`btn-team ${category === "sub12" ? "active-team" : null}`} title="Sub-12" onClick={() => this.chooseCategory('sub12')}>Sub-12</button>
			    <button type="button" className={`btn-team ${category === "sub14" ? "active-team" : null}`} title="Sub-14" onClick={() => this.chooseCategory('sub14')}>Sub-14</button>
			    <button type="button" className={`btn-team ${category === "sub16" ? "active-team" : null}`} title="Sub-16" onClick={() => this.chooseCategory('sub16')}>Sub-16</button>
			    <button type="button" className={`btn-team ${category === "sub18" ? "active-team" : null}`} title="Sub-18" onClick={() => this.chooseCategory('sub18')}>Sub-18</button>
			</div>	
				<div>
					  <div className="text-center pb-3">
					  </div>
					  {categoryPicture}
					  <h5 className="text-center px">Categoría {category}</h5>
					  {body}
			    </div>
	    </div>
				)
}

}
export default Team;

